import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import Swal from "sweetalert2";
import modeloImpressaoService from "../../../../../../services/ModeloImpressaoService";
import './index.css';
import { ItemImpressao } from "./ItemImpressao";

const listaLoading = (
  <>
    <div className="item-loading skeleton-animation"></div>
    <div className="item-loading skeleton-animation"></div>
    <div className="item-loading skeleton-animation"></div>
    <div className="item-loading skeleton-animation"></div>
    <div className="item-loading skeleton-animation"></div>
  </>
)

export function ImpressaoDocumento({ticket}){
  const [listaModelosContratuais, setListaModelosContratuais] = useState([]);
  const {promiseInProgress:loadingLista} = usePromiseTracker({area: 'loading-modelos-impressao'})

  useEffect(()=>{
    if(ticket?.id_processo){
      trackPromise(modeloImpressaoService.buscarModelosImpressaoTicketPorProcesso(ticket.id_processo).then((response)=>{
        setListaModelosContratuais(response.data);
      }).catch((error)=>{
        Swal.fire({
          title: 'Ooops...',
          text: 'Ocorreu um erro ao buscar documentos para impressão.',
          icon: 'error',
        }) 
      }), 'loading-modelos-impressao')
    }
  },[ticket.id_processo])

  return (
    <div className="modelos-contratuais-impressao-section">
      {
        loadingLista ?
        listaLoading :
        (listaModelosContratuais?.length ?
          <div className="lista-modelos-section">
            {
              listaModelosContratuais?.map((item, index)=>{
                return(
                  <ItemImpressao key={index} modeloContratual={item} idTicket={ticket.id_ticket}/>
                )
              })
            }
          </div>
          :
          <Alert variant="info">Nenhum documento para impressão encontrado!</Alert>
        )
      }
    </div>
  )
}
